import {
  ADD_CALENDAR_DATA,
  ADD_AVAILABILITY_DATA,
  CALENDAR_ERROR,
  CALENDAR_SUCCESS,
  ADD_HOLIDAY_DATA,
  UPDATE_HOLIDAY_DATA_INPROGRESS,
  ADD_HOLIDAY_SUCCESS,
  ADD_HOLIDAY_ERROR,
  EDIT_HOLIDAY_SUCCESS,
  EDIT_HOLIDAY_ERROR,
  DELETE_HOLIDAY_SUCCESS,
  DELETE_HOLIDAY_ERROR,
} from '../../../actions'

const initialState = {
  message: '',
  successMessage: '',
}
export const addCalendarDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_CALENDAR_DATA:
      const { user_id, payload } = action
      if (!state[user_id]) {
        state[user_id] = []
      }

      // const userData = new Set([...state[user_id], ...payload])

      return { ...state, [user_id]: [...payload], message: action.message }

    case CALENDAR_ERROR:
      return { ...state, message: action.message }

    case CALENDAR_SUCCESS:
      return { ...state, successMessage: action.successMessage }

    default:
      return state
  }
}

export const addAvailabilityDataReducer = (state = {}, action) => {
  switch (action.type) {
    case ADD_AVAILABILITY_DATA:
      return { ...action.payload }

    default:
      return state
  }
}

const initialHolidayState = {
  data: [],
  fetchInProgress: false,
}

export const addHolidayDataReducer = (state = initialHolidayState, action) => {
  switch (action.type) {
    case ADD_HOLIDAY_DATA:
      return { ...action.payload }
    case UPDATE_HOLIDAY_DATA_INPROGRESS:
      return { ...state, fetchInProgress: action.inProgress }
    default:
      return state
  }
}

const addHoliday = {
  add_holiday_success: false,
  add_holiday_error: false,
}

export const addHolidayResponseReducer = (state = addHoliday, action) => {
  switch (action.type) {
    case ADD_HOLIDAY_SUCCESS:
      return { ...state, add_holiday_success: true, edit_holiday_error: false }
    case ADD_HOLIDAY_ERROR:
      return { ...state, add_holiday_success: false, edit_holiday_error: true }

    default:
      return state
  }
}
const editHoliday = {
  edit_holiday_success: false,
  edit_holiday_error: false,
}

export const editHolidayResponseReducer = (state = editHoliday, action) => {
  switch (action.type) {
    case EDIT_HOLIDAY_SUCCESS:
      return { ...state, edit_holiday_success: true, edit_holiday_error: false }
    case EDIT_HOLIDAY_ERROR:
      return { ...state, edit_holiday_success: false, edit_holiday_error: true }

    default:
      return state
  }
}

const deleteHoliday = {
  delete_holiday_success: false,
  delete_holiday_error: false,
}
export const deleteHolidayResponseReducer = (state = deleteHoliday, action) => {
  switch (action.type) {
    case DELETE_HOLIDAY_SUCCESS:
      return { ...state, delete_holiday_success: true, delete_holiday_error: false }
    case DELETE_HOLIDAY_ERROR:
      return { ...state, delete_holiday_success: false, delete_holiday_error: true }

    default:
      return state
  }
}
